import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Alert,
  Button,
  DialogActions,
} from "@mui/material";
import PropTypes from "prop-types";

const ViewAlertResizes = ({ instanceId, open, onClose, onValidationResult }) => {
  const handleClose = () => {
    onClose();
    onValidationResult(false); // Indica que no se debe proceder
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Procesos Automáticos</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Alert severity="error">
            La instancia está registrada en el proceso de Apagados, Por favor Validar o comunicarse
            con arquitectura. Gracias
          </Alert>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

ViewAlertResizes.propTypes = {
  instanceId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onValidationResult: PropTypes.func.isRequired,
};

export default ViewAlertResizes;
